module.exports = __webpack_public_path__ + "static/media/vocacion.91b9dcee.png";


//////////////////
// WEBPACK FOOTER
// ./src/vocacion.png
// module id = 87
// module chunks = 0